import { ReactNode, SelectHTMLAttributes } from "react";
import { useFormContext } from "react-hook-form";
import tw from "twin.macro";

export interface Option {
  label: string | number;
  value: string | number;
}

interface Props extends SelectHTMLAttributes<HTMLSelectElement> {
  /**
   * @param label string
   * @param value string | number
   */
  options: Option[];
  name: string;
  label?: string | { label: string; value: string; hint: string };
  endAdornment?: ReactNode;
}

/**
 * @param options [Option]
 * @param name [string]
 */
export const SelectBox = ({
  options,
  label: labelProp,
  placeholder,
  endAdornment,
  ...htmlSelectProps
}: Props) => {
  const { register, watch } = useFormContext();

  const { name, ...rest } = htmlSelectProps;
  const value = watch(name);
  const label = labelProp || placeholder;

  return (
    <>
      <div tw="relative w-full h-12">
        <select
          tw="bg-gray w-full h-full py-0 px-4 flex items-center rounded-[9px] font-normal text-xs"
          css={value ? tw`text-black` : tw`text-secondary`}
          {...register(name)}
          {...rest}
        >
          {label &&
            (typeof label === "string" ? (
              <option value="">{label}</option>
            ) : (
              <option value={label.value}>{label.label}</option>
            ))}
          {options.map((option) => (
            <option
              key={option.value}
              value={option.value}
              tw="font-normal text-xs text-[#454b54]"
            >
              {option.label}
            </option>
          ))}
        </select>
        {endAdornment && (
          <div tw="absolute h-full flex-center top-0 right-0 px-4">
            {endAdornment}
          </div>
        )}
      </div>
      {typeof label === "object" && (
        <span tw="text-2xs text-secondary ml-1">{label.hint}</span>
      )}
    </>
  );
};
